// extracted by mini-css-extract-plugin
export default {"HeaderBox":"header_HeaderBox__p0pVB"};